import { FormBase } from 'core/components';

export default class DiagnosisCodeEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'abrv',
                    label: 'DIAGNOSIS_CODE.EDIT.CODE_LABEL',
                    placeholder: 'DIAGNOSIS_CODE.EDIT.CODE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'code',
                    label: 'DIAGNOSIS_CODE.EDIT.CODE_LABEL',
                    placeholder: 'DIAGNOSIS_CODE.EDIT.CODE_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'name',
                    label: 'DIAGNOSIS_CODE.EDIT.NAME_LABEL',
                    placeholder: 'DIAGNOSIS_CODE.EDIT.NAME_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: "diagnosisCodeCategories",
                    label: "DIAGNOSIS_CODE.EDIT.CATEGORIES_LABEL",
                    placeholder: "DIAGNOSIS_CODE.EDIT.CATEGORIES_PLACEHOLDER",
                    rules: "array"
                },
                {
                    name: "diagnosisCodeJustificationTypes",
                    label: "DIAGNOSIS_CODE.EDIT.JUSTIFICATION_TYPES_LABEL",
                    placeholder: "DIAGNOSIS_CODE.EDIT.JUSTIFICATION_TYPES_PLACEHOLDER",
                    rules: "array"
                },
                {
                    name: 'isBillable',
                    type: 'bool',
                    value: false
                },
            ],
        };
    }
}
